import bem from 'utils/bem';

export const block = bem('legacy-text-modal');
